import { useAuth } from '@framework/auth/state/AuthSlice.tsx';
import { HeaderRightMenu } from '@framework/ui/components/layout/header/HeaderRightMenu.tsx';
import { Space } from 'antd';
import type React from 'react';
import { LanguageMenu } from './LanguageMenu.tsx';
import { MobileFullMenu } from './MobileFullMenu.tsx';
import { FrontNotificationWrapper } from './notification/FrontNotificationWrapper.tsx';
import { NotificationsButton } from './notification/NotificationsButton.tsx';
import { UserMenu } from './UserMenu.tsx';

const enableLanguageMenu = process.env.ENABLE_LOCALIZATION === 'true';

export interface RightSideMenuProps {
  extra?: React.ReactNode;
  isMobile?: boolean | null;
  /** Forza la resa mobile di menu utente e lingua, senza menu hamburger */
  compact?: boolean;
}

export function RightMenu(props: RightSideMenuProps) {
  const { extra, isMobile, compact } = props;
  const { isLogged } = useAuth();
  const isCompact = Boolean(isMobile || compact);

  return (
    <HeaderRightMenu>
      <Space size={8}>
        {extra}
        {enableLanguageMenu && <LanguageMenu isMobile={isCompact} />}
        {isMobile && <MobileFullMenu />}
        {isLogged && (
          <FrontNotificationWrapper>
            <NotificationsButton />
          </FrontNotificationWrapper>
        )}
        <UserMenu isMobile={isCompact} />
      </Space>
    </HeaderRightMenu>
  );
}
